import type { DefineDateTimeFormat, I18nOptions } from 'vue-i18n';

import { availableLanguages } from '@sysarb/sysarb-types/general/locales';

export type DateFormatKey = 'monthAndDayAndYear' | 'monthAndDay' | 'year' | 'short' | 'long';

const dateFormatDefault: DefineDateTimeFormat = {
    monthAndDayAndYear: {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    },
    monthAndDay: {
        month: 'short',
        day: 'numeric'
    },
    year: {
        year: 'numeric'
    },
    short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    },
    long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric'
    }
};

const dateFormats: I18nOptions['datetimeFormats'] = {
    en: { ...dateFormatDefault },
    sv: { ...dateFormatDefault },
    nb: { ...dateFormatDefault },
};

export function getDateFormats(): I18nOptions['datetimeFormats'] {
    const result = { ...dateFormats };

    for (const lang of availableLanguages) {
        if (lang in result) continue;
        result[lang] = dateFormatDefault;
    }

    return result;
}
